
export const getMyInvestorMobileNumber = (context, createdBy, parameters, result) => {
  // eslint-disable-next-line no-warning-comments
  // TODO: Have to fix this, no number in the output.
  const { mobileNumber } = result.investor || {}

  return `+${mobileNumber}`
}
